import React, { useState, useEffect } from 'react';
import { fetchAllNotifications } from "../../Services/NotificationService";
import { Notification } from "./Notification";

const Notifications = () => {
    const [notifications, setNotifications] = useState([]);

    useEffect(() => {
        if (notifications.length === 0) {
            getNotifications();
        }
    }, [notifications]);

    const getNotifications = async () => {
        const data = await fetchAllNotifications();
        setNotifications(data);
    }

    return <div className="flex flex-col items-start shadow-sm border border-gray-400 rounded-md py-3 px-4 w-full h-64">
    <div className="w-full mb-4 sticky">
        <p className="font-bold text-xl text-left w-full text-stone-700">
            <span className="text-green-600 font-bold not-italic ms-2">Notifications</span>
        </p>
    </div>
    <div className="w-full cursor-pointer overflow-y-auto flex-grow">
        {notifications && notifications.length > 0 ? (
            notifications.map((notification, index) => (
                <Notification key={index} notification={notification} />
            ))
        ) : (
            <p>No notifications available</p>
        )}
    </div>
</div>
}
export { Notifications };
